import { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faPlus, faBars } from "@fortawesome/free-solid-svg-icons";
import { listarFacturacion } from "../../../api/facturacion";
import { Button, Dropdown, Badge } from "react-bootstrap";
import { withRouter } from "../../../utils/withRouter";
import { useNavigate } from "react-router-dom";
import EliminarFacturacion from "./Eliminar";
import ModificarFacturacion from "./Modificar";
import DatosdeFacturacion from "./DatosdeFacturacion";
import BasicModal from "../../Modal/BasicModal/BasicModal";
import { Load } from "../../load/load";
import { getTokenApi, obtenidusuarioLogueado } from "../../../api/auth";
import { obtenerUsuario } from "../../../api/usuarios";
import { toast } from "react-toastify";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function TblFacturacion(props) {
  const { location, history } = props;

  const [tipoUsuario, setTipoUsuario] = useState("");

  const obtenerDatosUsuario = () => {
    try {
      obtenerUsuario(obtenidusuarioLogueado(getTokenApi()))
        .then((response) => {
          const { data } = response;
          setTipoUsuario(data.tipo);
        })
        .catch((e) => {
          if (e.message === "Network Error") {
            //console.log("No hay internet")
            toast.error("Conexión al servidor no disponible");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    obtenerDatosUsuario();
  }, []);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula una carga de datos
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const [listarFacturaciones, setListFacturacion] = useState([]);

  // Para definir el enrutamiento
  const enrutamiento = useNavigate();

  const obtenerFacturacion = () => {
    try {
      listarFacturacion()
        .then((response) => {
          const { data } = response;

          if (!listarFacturaciones && data) {
            setListFacturacion(formatModelFacturacion(data));
          } else {
            const datosFacturacion = formatModelFacturacion(data);
            setListFacturacion(datosFacturacion);
          }
        })
        .catch((e) => {});
    } catch (e) {}
  };

  useEffect(() => {
    obtenerFacturacion();
  }, [location]);

  // Configurando animacion de carga
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);

  const cargarDatos = () => {
    const timeout = setTimeout(() => {
      setRows(listarFacturaciones);
      setPending(false);
    }, 0);
    return () => clearTimeout(timeout);
  };

  useEffect(() => {
    cargarDatos();
  }, []);

  //Para el modal
  const [showModal, setShowModal] = useState(false);
  const [contentModal, setContentModal] = useState(null);
  const [titulosModal, setTitulosModal] = useState(null);

  const registroFacturacion = (content) => {
    setTitulosModal("Registrar facturacion");
    setContentModal(content);
    setShowModal(true);
  };

  const modificarFacturacion = (content) => {
    setTitulosModal("Modificar facturacion");
    setContentModal(content);
    setShowModal(true);
  };

  const eliminarFacturacion = (content) => {
    setTitulosModal("Eliminar facturacion");
    setContentModal(content);
    setShowModal(true);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded", // "excluded" significa oculto por defecto
      },
    },
    {
      name: "rfc",
      label: "RFC",
    },
    {
      name: "razonSocial",
      label: "RAZÓN SOCIAL",
    },
    {
      name: "regimenFiscal",
      label: "REGIMEN FISCAL",
    },
    {
      name: "calle",
      label: "CALLE",
    },
    {
      name: "numeroExterior",
      label: "NUMERO EXTERIOR",
    },
    {
      name: "numeroInterior",
      label: "NUMERO INTERIOR",
    },
    {
      name: "codigoPostal",
      label: "CODIGO POSTAL",
    },
    {
      name: "colonia",
      label: "COLONIA",
    },
    {
      name: "municipio",
      label: "MUNICIPIO",
    },
    {
      name: "estadoPais",
      label: "ESTADO",
    },
    {
      name: "observaciones",
      label: "OBSERVACIONES",
    },
    {
      name: "estado",
      label: "STATUS",
      options: {
        customBodyRender: (value) => {
          const estado = value;

          let estiloTexto = "";
          let estadoTexto = "";

          if (estado == "true") {
            estiloTexto = "Activo";
            estadoTexto = "Activo";
          } else {
            estiloTexto = "Inhabilitado";
            estadoTexto = "Inhabilitado";
          }

          return <>
          <Badge
            bg={estado == "true" ? "success" : "danger"}
            //className="estado"
          >
            {estiloTexto}
          </Badge>
        </>;
        },
      },
    },
    {
      name: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tipoUsuario != "consultorio" || "doctor" ? (
            <>
              <Dropdown>
              <Dropdown.Toggle
                  className="botonDropdown"
                  id="dropdown-basic"
                >
                  <FontAwesomeIcon icon={faBars} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                   onClick={() =>
                    modificarFacturacion(
                      <ModificarFacturacion
                        history={history}
                        setShow={setShowModal}
                        data={tableMeta.rowData}
                      />
                    )
                  }
                  >
                    <FontAwesomeIcon
                      icon={faPen}
                      style={{ color: "#ffc107" }}
                    />
                    &nbsp; Modificar
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                        eliminarFacturacion(
                          <EliminarFacturacion
                            history={history}
                            setShow={setShowModal}
                            data={tableMeta.rowData}
                          />
                        )
                      }
                  >
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{ color: "#dc3545" }}
                    />
                    &nbsp; Eliminar
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : (
            "No disponibles"
          );
        },
      },
    },
  ];

  const theme = useTheme();
  const isSmOrDown = useMediaQuery(theme.breakpoints.down('sm'));

  const options = {
    filterType: "checkbox",
    responsive: isSmOrDown && 'standard',
    selectableRows: isSmOrDown ? 'none' : 'multiple',
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `ordenar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Registros por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
      },
      filter: {
        all: "Todos",
        title: "FILTROS",
        reset: "RESTAURAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  return (
    <>
      {loading && <Load />}
      <h1>Datos Fiscales</h1>
      <div>
        <div className="divButton">
          <Button
            className="btnAddTables"
            onClick={() =>
              registroFacturacion(
                <DatosdeFacturacion history={history} setShow={setShowModal} />
              )
            }
          >
            <FontAwesomeIcon icon={faPlus} /> Agregar
          </Button>
        </div>
      </div>
      <div className="divTabla">
        <MUIDataTable
          title={"Lista de datos fiscales registradas"}
          data={listarFacturaciones}
          columns={columns}
          options={options}
        />
      </div>
      <BasicModal show={showModal} setShow={setShowModal} title={titulosModal}>
        {contentModal}
      </BasicModal>
    </>
  );
}

function formatModelFacturacion(data) {
  const dataTemp = [];
  data.forEach((data) => {
    dataTemp.push({
      id: data._id,
      rfc: data.rfc,
      razonSocial: data.razonSocial,
      regimenFiscal: data.regimenFiscal,
      calle: data.calle,
      numeroExterior: data.numeroExterior,
      numeroInterior: data.numeroInterior,
      codigoPostal: data.codigoPostal,
      colonia: data.colonia,
      municipio: data.municipio,
      estadoPais: data.estadoPais,
      observaciones: data.observaciones,
      estado: data.estado,
    });
  });
  return dataTemp;
}

export default withRouter(TblFacturacion);
